<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>代理商管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/manage/index">代理商列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加代理商</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加代理商</span>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="160px"
          style="width: 50%"
        >
          <el-form-item label="登录账户：" prop="username">
            <el-input v-model="form_data.username" placeholder="请输入登录账户"></el-input>
          </el-form-item>
          <el-form-item label="密码：" v-if="id > 0">
            <el-row>
              <el-col :span="18">
                <el-input v-model="form_data.password" placeholder="如需更改请填写新密码，不填为原密码"></el-input>
              </el-col>
              <el-col :span="4" :push="1">
                <el-button type="primary" @click="rangPwd">随机密码</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="密码：" prop="password" v-else>
            <el-row>
              <el-col :span="18">
                <el-input v-model="form_data.password" placeholder="请输入登录密码"></el-input>
              </el-col>
              <el-col :span="4" :push="1">
                <el-button type="primary" @click="rangPwd">随机密码</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="联系人：" prop="contact">
            <el-input v-model="form_data.contact" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="mobile">
            <el-input v-model="form_data.mobile" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="绑定域名：" prop="uhost">
            <el-input v-model="form_data.uhost" placeholder="请输入绑定域名(例：ytk)"></el-input>
          </el-form-item>
          <el-form-item label="域名后缀：" prop="udomain">
            <el-input v-model="form_data.udomain" placeholder="请输入绑定域名(例：yitku.com)"></el-input>
          </el-form-item>
          <el-form-item label="到期时间：" prop="etime">
            <el-form-item prop="etime">
              <el-date-picker
                type="date"
                placeholder="请选择到期时间"
                v-model="form_data.etime"
                value-format="timestamp"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item label="状态：">
            <el-radio-group v-model="form_data.status">
              <el-radio :label="1">已通过</el-radio>
              <el-radio :label="0">待审核</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()" :loading="saveLoading">保存</el-button>
            <el-button type="primary" @click="back()">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      saveLoading: false,
      form_data: {
        username: "",
        password: "",
        contact: "",
        mobile: "",
        uhost: "",
        udomain: "",
        etime: "",
        status: 1,
      },
      postData: [],
      id: "",
      rules: {
        username: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        uhost: [{ required: true, message: "请输入绑定域名", trigger: "blur" }],
        udomain: [
          { required: true, message: "请输入绑定域名", trigger: "blur" },
        ],
      },
    };
  },
  /**
   * 进入页面加载
   */
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    } else {
      that.loading = false;
    }
  },
  methods: {
    rangPwd() {
      var Num = "";
      for (var i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      this.form_data.password = Num;
    },
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios
        .post("/manage/edit", {
          id: that.id,
        })
        .then((res) => {
          that.form_data = res.data;
          if (res.data.uhost) {
            that.form_data.urls = res.data.uhost + "." + res.data.udomain;
          }
          if (res.data.etime) {
            that.form_data.etime = res.data.etime * 1000;
          } else {
            that.form_data.etime = "";
          }
          that.loading = false;
        });
    },
    save() {
      const that = this;
      that.saveLoading = true;
      that.$refs.form_data.validate((valid) => {
        if (!valid) {
          that.$message.warning("请完整填写内容!");
          return (that.saveLoading = false);
        }
        var formData = {};
        formData = that.form_data;
        var url = "/manage/store";
        if (that.id) {
          formData.id = that.id;
          url = "/manage/update";
        }
        that.axios.post(url, formData).then(() => {
          that.saveLoading = false;
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/manage/index");
        });
      });
    },
    /**
     * 返回
     */
    back() {
      this.$router.push("/manage/index");
    },
  },
};
</script>
<style>
.el-cascader-menu {
  overflow: hidden;
  width: 200px;
}
.el-scrollbar__wrap {
  overflow: auto;
}
</style>